import React, { useEffect, useState } from "react";
import { ChevronDown } from "lucide-react";
import PublicLayout, { H1, Lead, SectionCta } from "../../components/PublicLayout";
import { SITE } from "../../content/site";
import { routePath } from "../../lib/routes";
import { track, EVENTS } from "../../lib/analytics";

export default function Faq({ lang }) {
  const c = SITE[lang].faq;
  const [open, setOpen] = useState(0);
  useEffect(() => { window.scrollTo(0, 0); }, [lang]);
  const ld = [{
    "@context": "https://schema.org", "@type": "FAQPage",
    mainEntity: c.items.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
  }];
  return (
    <PublicLayout pageKey="faq" lang={lang} jsonLd={ld}
      crumbs={[{ name: SITE[lang].breadcrumbs.faq, path: routePath("faq", lang) }]}>
      <div className="mx-auto max-w-[820px] px-6 py-14 md:px-8 md:py-20" data-testid="faq-page">
        <H1>{c.h1}</H1>
        <Lead>{c.intro}</Lead>
        <div className="mt-12 divide-y divide-black/8 border-y border-black/8">
          {c.items.map((f, i) => (
            <div key={i}>
              <button onClick={() => setOpen(open === i ? null : i)} aria-expanded={open === i} data-testid={`faq-q-${i}`}
                className="flex w-full items-center justify-between gap-4 py-6 text-left">
                <h2 className="text-base font-normal text-[#050505] md:text-lg">{f.q}</h2>
                <ChevronDown size={18} className={`shrink-0 text-[#9a9d98] transition-transform ${open === i ? "rotate-180" : ""}`} />
              </button>
              {open === i && <p className="pb-6 text-base font-light leading-relaxed text-[#6b6f6c]">{f.a}</p>}
            </div>
          ))}
        </div>
        <SectionCta title={SITE[lang].services.cta.title} text={SITE[lang].services.cta.text} lang={lang}
          onClick={() => track(EVENTS.CTA_CLICK, { cta: "faq_contact" })} />
      </div>
    </PublicLayout>
  );
}
